import type { TFunction } from "i18next"
import { z } from "zod"

export const editCustomerSchema = (t: TFunction) =>
  z.object({
    email: z
      .string()
      .min(1, t("validation.required"))
      .email(t("validation.invalidEmail")),
    mobilePhone: z
      .string()
      .min(1, t("validation.required"))
      .refine(
        (val) => {
          const digits = val.replaceAll(/\D/g, "")
          return digits.length >= 10 && digits.length <= 11
        },
        {
          message: t("pages.customers.edit.invalidPhone"),
        }
      ),
  })

export type EditCustomerSchemaProps = z.infer<
  ReturnType<typeof editCustomerSchema>
>
